import { classNameTag } from '../../../utils/class-name-tag';
const bannerTag = (...tags) => classNameTag('Banner', ...tags);
const bannerType = (type) => bannerTag(type || 'custom');
export const BannerTags = {
    type: bannerType,
    iconWrapper: bannerTag('icon-wrapper'),
};
//# sourceMappingURL=class-name-tags.js.map